export default __webpack_public_path__ + "static/media/BuildRing_Generic_XLG.5688f61a.jpg";